import { Button } from '../../../../components/Button/Button'
import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { useLocation, useNavigate } from 'react-router-dom'
import { useZocksAuth } from '../../../../components/ScopedBlock/hooks'
import { type CrossClientQueryExecution, type CrossClientQueryPhase, CrossClientQueryPhases } from '../../../../models/CrossClient'
import { CrossClientExecutionActions } from '../../Landing/CrossClientExecutionActions'
import { CCQ_BACK_LABEL } from '../Run/ccqRunCopy'
import { HeaderContext } from '../../../LayoutWithLeftSidebar/HeaderContext'

// A schedule copies the execution's mappings, which these phases never got.
const UNSCHEDULABLE_PHASES: CrossClientQueryPhase[] = [
  CrossClientQueryPhases.INITIALIZING,
  CrossClientQueryPhases.ERRORED,
  CrossClientQueryPhases.QUESTION_ERROR,
]

interface CrossClientHeaderProps {
  execution: CrossClientQueryExecution
}

export const CrossClientHeader: React.FC<CrossClientHeaderProps> = ({ execution }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const fromTab = (state as { fromTab?: string } | null)?.fromTab

  const { hasScope } = useZocksAuth()
  const canSchedule = hasScope('**', 'schd_ccq:create', ['schd_ccq:admin']) && !UNSCHEDULABLE_PHASES.includes(execution.phase)

  const handleBackButtonClicked = () => {
    navigate(fromTab ? `/cross-client?tab=${encodeURIComponent(fromTab)}` : '/cross-client')
  }

  const handleScheduleClicked = () => {
    navigate(`/cross-client/executions/${execution.id}/schedule`)
  }

  return (
    <div className='d-flex align-items-center justify-content-between w-100 pe-2'>
      <div className='zocks-pl-2.0'>
        <Button variant='link' className='back-button' onClick={handleBackButtonClicked} aria-label={CCQ_BACK_LABEL}>
          <i className='bi bi-chevron-left' aria-hidden='true' />
        </Button>
      </div>
      <div className='d-flex align-items-center gap-2'>
        {canSchedule ? (
          <Button
            variant='header'
            className='cross-client-schedule-button d-flex align-items-center gap-2 bg-white zocks-border-0.5 zocks-border-color-gray-300'
            onClick={handleScheduleClicked}
          >
            <i className='bi bi-calendar2-plus' />
            <span className='paragraph-small medium'>Schedule query</span>
          </Button>
        ) : null}
        <CrossClientExecutionActions execution={execution} onDeleted={handleBackButtonClicked} />
      </div>
    </div>
  )
}

export const CrossClientHeaderPortal: React.FC<CrossClientHeaderProps> = ({ execution }) => {
  const { portalElement } = useContext(HeaderContext)
  return portalElement ? createPortal(<CrossClientHeader execution={execution} />, portalElement) : null
}
